import React, { Component } from "react";
import { LinearProgress, Typography } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import {
  getConditionsLeftAsText,
  getSmartPromoProgress,
} from "../../Helpers/promotions";
import { getCurrencyIso } from "../../Helpers/currencyConverter";

const styles = (theme) => ({
  bar: {
    borderRadius: 100,
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  },
});
class SmartPromotionProgressBar extends Component {
  getDiscountsText(discounts) {
    const { language, settings } = this.props;

    let product = null;
    const currency = getCurrencyIso(settings, language);
    let discountsText = [];

    discounts.forEach((discount) => {
      if (discount.type === "fixed") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} ${currency} خصم`
            : `${discount.value} ${currency} off`,
        );
      } else if (discount.type === "percent") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} % خصم`
            : `${discount.value} % off`,
        );
      } else if (discount.type === "products") {
        product = discount.products[0];
        if (product) {
          discountsText.push(
            language === "arabic"
              ? `${product.quantity} × ${product.ar_name || product.name}`
              : `${product.quantity} × ${product.name}`,
          );
        }
      } else if (discount.type === "delivery") {
        discountsText.push(
          language === "arabic" ? "توصيل مجاني" : "Free delivery",
        );
      } else if (discount.type === "delivery_percent") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} % خصم على رسوم التوصيل`
            : `${discount.value} % off delivery charge`,
        );
      } else if (discount.type === "category") {
        let category = this.props.categories.find(
          (category) => category.id === discount.categories[0],
        );
        if (category) {
          discountsText.push(
            language === "arabic"
              ? `${discount.value} % خصم على ${
                  category.ar_name || category.name
                }`
              : `${discount.value} % off ${category.name}`,
          );
        }
      } else if (discount.type === "products_percent") {
        let productName = "";
        for (let category of this.props.categories) {
          let product = category.products?.find(
            (product) => product.id === discount.products[0],
          );
          if (product) {
            productName =
              language === "arabic"
                ? product.ar_name || product.name
                : product.name;
            break;
          }
        }

        if (productName) {
          discountsText.push(
            language === "arabic"
              ? `${discount.value} % خصم على ${productName}`
              : `${discount.value} % off ${productName}`,
          );
        }
      } else if (discount.type === "modifier") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} % خصم على بعض الاضافات`
            : `${discount.value} % off on certain modifiers`,
        );
      } else if (discount.type === "category_free") {
        let category = this.props.categories.find(
          (category) => category.id === discount.categories[0],
        );
        if (category) {
          discountsText.push(
            language === "arabic"
              ? `${discount.value} منتجات مجانية من ${
                  category.ar_name || category.name
                }`
              : `${discount.value} free products from ${category.name}`,
          );
        }
      } else if (discount.type === "cashback_percent") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} % من إجمالي الطلب يضاف إلى المحفظة`
            : `${discount.value} % of the order's total added to wallet`,
        );
      } else if (discount.type === "cashback_fixed") {
        discountsText.push(
          language === "arabic"
            ? `${discount.value} ${currency} يضاف إلى المحفظة`
            : `${discount.value} ${currency} added to wallet`,
        );
      }
    });

    return discountsText;
  }
  getHighestValuePromotion = () => {
    const { smartPromos } = this.props;

    let highestPromotion = null;

    smartPromos
      .filter((p) => !p.hide_promotion)
      .forEach((p) => {
        const { progressValue, conditionsLeft } = getSmartPromoProgress(
          p,
          this.props,
        );

        if (
          !highestPromotion ||
          progressValue > highestPromotion.progressValue
        ) {
          highestPromotion = {
            promotion: p,
            progressValue,
            conditionsLeft,
          };
        }
      });
    return highestPromotion;
  };
  render() {
    const { smartPromos } = this.props;

    const { promotion, progressValue, conditionsLeft } =
      this.getHighestValuePromotion();

    if (!promotion || progressValue >= 100) {
      return null;
    }
    const conditionsLeftText = getConditionsLeftAsText(
      conditionsLeft,
      this.props,
      true,
    );

    const discountsText = this.getDiscountsText(promotion.discounts);

    return (
      <div
        className={`${
          this.props.language == "english"
            ? "action-button-english"
            : "action-button-arabic"
        } ${
          (this.props.settings.enable_aseer_time &&
            "action-button-tabs-space") ||
          ""
        }`}
        style={{
          position: "fixed",
          zIndex: 5,
          marginBottom: -20,
          backgroundColor: "white",
          alignItems: "center",
          display: "flex",
          bottom:
            this.props.settings.enable_loyalty_points_page &&
            window.outerWidth < 768
              ? 105
              : 60,
          marginBottom:
            this.props.settings.enable_aseer_time && window.outerWidth < 768
              ? 60
              : 0,
          height: 60,
          borderTop: `1px solid rgba(0, 0, 0, .125)`,
        }}
      >
        <div
          style={{
            alignItems: "center",
            marginBottom: "8px",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              overflow: "hidden",
              marginRight: "16px",
              justifyContent: "center",
              direction: this.props.language === "arabic" && "rtl",
            }}
          >
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginRight: "8px", fontWeight: "bold", color: "black" }}
            >
              {conditionsLeftText[0]}{" "}
              {this.props.language === "arabic" ? " لكي تحصل على " : " to get "}
              {[discountsText[0]]}
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              flex: "1",
              justifyContent: "center",
              marginBottom: "-15px",
            }}
          >
            <LinearProgress
              variant="determinate"
              value={progressValue}
              style={{ width: "90%", marginRight: "8px" }}
            />
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ fontWeight: "bold", color: "black" }}
            >
              {`${Math.round(progressValue)}%`}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    secondLoading: state.store.secondLoading,
    appliedCoupon: state.cart.promos,
    discounts: state.cart.discounts,
    totalPrice: state.cart.price,
    totalItems: state.cart.number_of_items,
    themeColor: state.store.store.settings.dark,
    cart: state.cart.cart,
    customerAddress: state.customers.address,
    branch: state.branch,
    authUser: state.auth.user,
    delivery: state.delivery,
    categories: state.store.store.categories,
    smartPromos: state.store.store.smart_promos,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withStyles(styles)(SmartPromotionProgressBar)));
